import { Controller } from "@hotwired/stimulus"

/**
 * Listicle Editor Controller
 * Handles adding/removing/reordering items in the listicle wizard
 */
export default class extends Controller {
  static targets = ["form", "itemsContainer", "itemsList", "itemTemplate", "startNumber"]

  itemIndex = 0

  connect() {
    // Initialize index based on existing items
    const existingCards = this.itemsListTarget.querySelectorAll(".item-card")
    this.itemIndex = existingCards.length
  }

  addItem(event) {
    event.preventDefault()

    const startNumber = parseInt(this.startNumberTarget?.value || "5")
    const countDirection = document.querySelector("[name='video_config[count_direction]']")?.value || "down"

    const template = this.itemTemplateTarget.innerHTML
    const rank = countDirection === "down"
      ? startNumber - this.itemIndex
      : this.itemIndex + 1

    const newItem = template
      .replace(/INDEX/g, this.itemIndex.toString())
      .replace(/RANK/g, rank.toString())

    const tempDiv = document.createElement("div")
    tempDiv.innerHTML = newItem
    const itemCard = tempDiv.firstElementChild

    this.itemsListTarget.appendChild(itemCard)
    this.itemIndex++

    // Focus the title field
    const titleInput = itemCard.querySelector("input[name*='[title]']")
    if (titleInput) titleInput.focus()
  }

  removeItem(event) {
    event.preventDefault()

    const card = event.target.closest(".item-card")
    if (!card) return

    // Don't allow removing below minimum items
    const allCards = this.itemsListTarget.querySelectorAll(".item-card")
    if (allCards.length <= 3) {
      alert("Listicle must have at least 3 items")
      return
    }

    card.remove()
    this.updateRankNumbers()
  }

  updateListSize(event) {
    const newSize = parseInt(event.target.value) || 5
    const existingCards = Array.from(this.itemsListTarget.querySelectorAll(".item-card"))

    // Remove excess items from the end
    while (existingCards.length > newSize) {
      const card = existingCards.pop()
      card.remove()
      this.itemIndex--
    }

    // Add more items if needed
    while (this.itemsListTarget.querySelectorAll(".item-card").length < newSize) {
      this.addItemWithoutFocus()
    }

    this.updateRankNumbers()
  }

  addItemWithoutFocus() {
    const startNumber = parseInt(this.startNumberTarget?.value || "5")
    const countDirection = document.querySelector("[name='video_config[count_direction]']")?.value || "down"

    const template = this.itemTemplateTarget.innerHTML
    const rank = countDirection === "down"
      ? startNumber - this.itemIndex
      : this.itemIndex + 1

    const newItem = template
      .replace(/INDEX/g, this.itemIndex.toString())
      .replace(/RANK/g, rank.toString())

    const tempDiv = document.createElement("div")
    tempDiv.innerHTML = newItem
    const itemCard = tempDiv.firstElementChild

    this.itemsListTarget.appendChild(itemCard)
    this.itemIndex++
  }

  updateRankNumbers() {
    const startNumber = parseInt(this.startNumberTarget?.value || "5")
    const countDirection = document.querySelector("[name='video_config[count_direction]']")?.value || "down"
    const cards = this.itemsListTarget.querySelectorAll(".item-card")

    cards.forEach((card, index) => {
      const rankSpan = card.querySelector("[data-listicle-editor-target='rankNumber']") ||
                       card.querySelector(".text-xl.font-bold")
      if (rankSpan) {
        const rank = countDirection === "down" ? startNumber - index : index + 1
        rankSpan.textContent = rank.toString()
      }
    })
  }
}
